import React from "react";
import Box from "@mui/material/Box";
import {Outlet} from "react-router-dom";
import {useIsMobile} from "@bounce/shared/consumer/helpers";
import {useDocumentMeta} from "@bounce/shared/hooks";
import {urls} from "routes/urls";
import SpringMenu from "./SpringMenu";
import DrawerMenu from "./DrawerMenu";

const SpringLayout = () => {
  const isMobile = useIsMobile();
  useDocumentMeta({urls, favicon: "/spring-favicon.svg", titlePrefix: "Spring"});

  return (
    <Box sx={{display: "flex", minHeight: "100vh"}}>
      {isMobile ? (
        <DrawerMenu>
          <SpringMenu />
        </DrawerMenu>
      ) : (
        <SpringMenu />
      )}
      <Outlet />
    </Box>
  );
};
export default SpringLayout;
